// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__y9RU1","row":"Node_row__3JC0N","label":"Node_label__105n-","footer":"Node_footer__1z13R"};